/* eslint-disable react/require-default-props */
import React from "react";

export default function PlusCircle({ cursor, onClick }: { cursor?: string; onClick?: () => void }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor={cursor}
      onClick={onClick}
    >
      <path
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        stroke="url(#paint0_linear_1579_7479)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12H15"
        stroke="url(#paint1_linear_1579_7479)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V15"
        stroke="url(#paint2_linear_1579_7479)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="paint0_linear_1579_7479" x1="12" y1="4" x2="12" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEDF3F" />
          <stop offset="0.0001" stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
        <linearGradient id="paint1_linear_1579_7479" x1="12" y1="12" x2="12" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEDF3F" />
          <stop offset="0.0001" stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
        <linearGradient id="paint2_linear_1579_7479" x1="12.5" y1="9" x2="12.5" y2="15" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEDF3F" />
          <stop offset="0.0001" stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const PlusCircle16 = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z"
        stroke="#38B000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.33594 8H10.6693" stroke="#38B000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10.6654V5.33203" stroke="#38B000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
